import { Tag } from 'antd';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { updateItem } from '../../containers/App/selectors';

type Props = {
  decor?: string;
  text: string;
};

const Wrap = styled.div`
  && {
    display: flex;
    .main {
      display: flex;
      align-items: center;
      .rectangle {
        width: 13px;
        height: 59px;
        background: #000000;
        border-top-left-radius: 10px;
        margin-right: 20px;
      }
    }
    .extra {
      display: flex;
      align-items: center;
    }
    .warning-fix {
      display: flex;
      align-items: center;
      margin-left: auto;
    }
    .warning {
      font-weight: 700;
      font-size: 14px;
      line-height: 30px;
    }
  }
`;

const RectangleItem: FC<Props> = ({ children, decor, text }) => {
  const { cpap_detail } = useSelector(updateItem);
  return (
    <Wrap className={decor}>
      <div className="main">
        <div className="rectangle" />
        <p className="largeBoldFont mb-0">{text}</p>
      </div>
      <div className="extra">{children}</div>
      {cpap_detail?.sp_price ? (
        <div className="warning-fix">
          <Tag color="default" className="warning">
            特別料金対象者
          </Tag>
        </div>
      ) : (
        ''
      )}
    </Wrap>
  );
};

export default RectangleItem;
